<template>
    <div class="loginVue">
        <div class="login-wrap">
            <div v-if="!isSubmitedSwitch" class="container">
                <div  v-loading="loading" class="col-md-5 col-sm-12 col-xs-12 login-inner">
                    <div class="row containing-table">
                        <div class="col-sm-3 col-xs-12 table-cell text-center o-login-left">
                            <img src="static/assets/images/logo.png">
                        </div>
                        <div class="col-sm-9 col-xs-12 table-cell text-left o-login-right">
                            <div class="form-group">
                                <div class="clearfix">
                                    <div class="form-group-left o-login-field">
                                        <label>{{ $t('select_union') }}:</label>
                                    </div>
                                    <div class="form-group-right o-login-field o-cutsomSelect">
                                        <!-- <input type="text" class="form-control u-transparent" placeholder="User name or email"> -->
                                        <select v-model="selectedClient" class="form-control u-transparent">
                                            <option value="">{{ $t('select') }} </option>
                                            <option v-for="client in clients" :value="client.client_id" :key="client.client_id">{{client.subdomain+' ('+client.contact_person+')'}}</option>
                                        </select>
                                    </div>
                                </div>
                            </div>
                            <div class="form-group">
                                <div class="clearfix">
                                    <a @click="goToClientView()" class="c-solid-btn c-solid-btn--green">{{ $t('continue') }} </a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="clearfix"></div>
            </div>
            <div class="clearfix"></div>
        </div>

        <modal name="client-switch-modal" :clickToClose="false" height="auto" :scrollable="true" class="modal-dialog modal-sm">
            <div id="" class="modal-add-call" tabindex="-1" role="dialog">
                <div  role="document">
                    <div class="modal-content o-common-modal-content">
                        <div class="modal-header u-no-border text-center modal-header--heading">
                            <!-- <button type="button" class="close custom-modal--close" data-dismiss="modal" aria-label="Close"><i class="fa fa-times" aria-hidden="true"></i></button>
                            <h1 class="modal-title">Add Files</h1> -->
                        </div>
                        <div class="col-md-12 col-sm-12 col-xs-12" style="padding: 10px;">
                                <div class="containing-table">
                                    <div class="col-sm-3 col-xs-12 table-cell text-center o-login-left login-left-spacing">
                                        <!-- <img src="static/assets/images/logo.png"> -->
                                        <img v-if="login_image && login_image != '' && login_image != 'NULL'" :src="login_image" width="100"/>
                                        <img v-if="!login_image || login_image == '' || login_image == 'NULL'" src="static/assets/images/logo.png" width="100" />
                                    </div>
                                    <div class="col-sm-9 col-xs-12 table-cell text-left o-login-right login-right-spacing">
                                        <transition name="">
                                            <div class="login-screen login-right-screen add-word-break-all">
                                                <p v-html="login_text"></p>
                                            </div>
                                        </transition>
                                    </div>
                                </div>
                            </div>
                        <div class="modal-footer text-center">
                            <div class="col-md-12">
                                <ul class="o-filter-area">
                                    <!-- <li>
                                        <a href="javascript: void(0)" class="c-common-btn c-common-btn--large c-common-btn--inverse-icon-blue"><i class="fa fa-minus-circle" aria-hidden="true"></i> Cancel</a>
                                    </li> -->
                                    <li>
                                        <a href="javascript: void(0)" @click="closeModal()" class="c-solid-btn c-solid-btn--large c-solid-btn--green"><i class="fa fa-floppy-o" aria-hidden="true"></i> {{ $t('continue') }}</a>
                                    </li>
                                </ul>
                            </div>
                        </div>


                    </div>
                    <!-- /.modal-content -->
                </div>

                <!-- /.modal-dialog -->
            </div>
        </modal>
    </div>
</template>
<script>
    import service from '../services';
    import {
        mapGetters,
        mapActions
    } from 'vuex';
    import {
        global
    } from '../global.js';
    import timeConvertCompare from '../timeConvert&Compare';
    export default {
        computed: {
            ...mapGetters({
                userID: 'userID',
                employeeId: 'employeeId',
                userToken: 'userToken',
                subDomain: 'getSubdomain',
                queryParamClientId: 'queryParamClientId',
                queryParamAppSource: 'queryParamAppSource'
            }),
            
        },
        data() {
            return {
                loading:true,
                clients:[],
                selectedClient:'',
                login_text:'',
                login_image:'',
                client_details:{},
                isSubmitedSwitch:false,
                is_power_steward_allowed: null,
                client_id: '',
                app_source: false
            }
        },
        watch: {},
        methods: {
            closeModal() {
                this.$modal.hide("client-switch-modal");
                let role = this.client_details?this.client_details.role: "";
                let is_steward = this.client_details&&this.client_details.user&&this.client_details.user.employees&&this.client_details.user.employees.length&&this.client_details.user.employees[0].is_steward? this.client_details.user.employees[0].is_steward : false;
                // console.log(this.client_details.user.employees[0]);
                if(role.slug == "power-user" || (role.slug == "employee" && is_steward&&this.is_power_steward_allowed)){
                    this.$router.push({
                        path: "/jobList"
                    });
                }else{
                    let isMobile=service.deviceDetector().isMobile;
                    // console.log('isMobile', isMobile);
                    if(isMobile){
                        this.$cookies.set("csLogin", this.client_details.role.slug, "23h", '/mobile');
                        if(!this.app_source){
                            window.location.href = window.location.href.split('#')[0]+'mobile/';
                        }else {
                            this.$router.push({
                                path: "/schedule/"+btoa(this.employeeId),
                            });
                        }
                    }else if(this.subDomain == timeConvertCompare.freelanceSubdomain()){
                        this.$router.push({
                            path: "/myProfile",
                        });
                    }else{
                        this.$router.push({
                            path: "/schedule/"+btoa(this.employeeId),
                        });
                    }
                }
                this.$modal.hide("client-switch-modal");
            },
            openModal() {
                this.$modal.show("client-switch-modal");
            },
            goToClientView(){
                // this.$router.push({
                //     path: "/schedule/"+btoa(this.employeeId),
                // });
                if(this.selectedClient.length != 0) {
                    this.switchClient();
                }
            },
            async getClientAssociationList(){
                this.loading = true;
                await service.get('employee/'+this.userID+'/getEmployeesAssociation', {
                    'Authorization': this.userToken,
                }).then(async(res) => {
                    // console.log(res);
                    this.clients = res.data.result;
                    if(this.app_source) {
                        this.selectedClient = this.client_id;
                        await this.switchClient();
                    } else if(this.clients.length == 1){
                        // await this.switchClient();
                        this.selectedClient = this.clients[0].client_id;
                        await this.switchClient();
                    }
                    // await this.switchClient();
                    this.loading = false;
                }).catch(err =>{
                    this.loading=false
                    console.log(err);
                });
            },
            getLoginGettings(){
                 service.get('client/getClientGreetings', {
                    'Authorization': this.userToken,
                    'clientId': this.selectedClient,
                }).then((res) => {
                    // console.log(res);
                    // this.clients=res.data.result;
                    // this.loading=false;
                }).catch(err =>{
                    // this.loading=false
                    console.log(err);
                });
            },
            async switchClient(){
                this.loading=true;
                await service.get('employee/getMUAEmployees', {
                    'Authorization': this.userToken,
                    'employeeId': this.employeeId,
                    'clientId': this.selectedClient,
                    'userId': this.userID
                }).then((res) => {
                    this.loading=false;
                    // console.log('switchClient',res.data.result);
                    localStorage.removeItem('vuex');
                    this.client_details = res.data.result;
                    // console.log(this.client_details);
                    this.$cookies.set("csLogin", this.client_details.role.slug, "23h");
                    // this.$cookies.set("powerSteward", this.client_details.user.employees[0].client_employee.clients.power_steward, "23h");
                    this.$store.dispatch('onSwitchClient', this.client_details);
                    this.login_image = this.client_details.user.employees[0].client_employee.clients.login_image;
                    this.login_text = this.client_details.user.employees[0].client_employee.clients.login_page_message;
                    this.is_power_steward_allowed = this.client_details.user.employees[0].client_employee.clients.power_steward;
                    this.isSubmitedSwitch=true;
                    this.openModal();
                    this.getLoginGettings();
                    /* for support chat box.*/
                    var a =JSON.parse(localStorage.getItem('vuex'));
                    var userRole =a && a.user && a.user.userData && a.user.userData.role?a.user.userData.role.slug:null;
                    if(userRole){
                        let tags = ['csSupport'];
                        var client = userRole!='employer-admin' && userRole!='employer' && userRole!='super-admin'?a.user.userData.user.employees[0].client[0].clients.subdomain:'';
                        if(userRole == 'employee'){
                            tags =JSON.parse(a.user.userData.user.employees[0].client[0].clients.widget_tags) && JSON.parse(a.user.userData.user.employees[0].client[0].clients.widget_tags).length ? JSON.parse(a.user.userData.user.employees[0].client[0].clients.widget_tags) : [client];
                            // console.log(tags);
                            tags.push('csSupport');
                        }
                        
                        // window.fcWidget.init({
                        //     token:"5f5b4092-cff9-4586-9c85-5d4c79365f71",
                        //     host: "https://wchat.freshchat.com",
                        //     tags: tags,
                        //     config: {
                        //         headerProperty: {
                        //         backgroundImage: 'https://admin.callsteward.com/static/assets/images/login-bg.jpg',
                        //         //Hide the chat button on load
                        //         hideChatButton: false,
                        //         //Set Widget to be left to right.
                        //         // direction: 'ltr'
                        //         }
                        //     }
                        // });
                                    
                        window.fcWidget.setTags(tags);
                        // To set unique user id in your system when it is available
                        window.fcWidget.setExternalId(a.user.userData.user.id);

                        // To set user name
                        window.fcWidget.user.setFirstName(a.user.userData.user.first_name);

                        window.fcWidget.user.setLastName(a.user.userData.user.last_name);

                        // To set user email
                        window.fcWidget.user.setEmail(a.user.userData.user.email);
                        var phone = a.user.userData.user.phones.length>0 ? a.user.userData.user.phones[0].phone_number : '';
                        window.fcWidget.user.setPhone(String(phone));

                        // To set user properties
                        window.fcWidget.user.setProperties({
                            plan: "Estate",                 // meta property 1
                            status: "Active",                // meta property 2
                            phone: String(phone),
                            client: String(client),   // user's meta property 3
                            role: String(userRole)
                        });

                        //console.log('setProperties',phone, client);
                    }
                    if(this.app_source && this.client_id != ''){
                        this.closeModal();
                        // this.$store.dispatch('setQueryParamClientId', this.client_id); queryParamClientId: 'queryParamClientId',
                        //   queryParamAppSource: 'queryParamAppSource'
                        // this.$store.dispatch('setQueryParamAppSource', this.app_source);
                    }
                    /* END CHAT SUPPORT */
                }).catch(err =>{
                    this.loading=false
                    console.log(err);
                });
            }
        },
        mounted() {},
        beforeMount() {},
           
        async created() {
            this.app_source = this.$route.query.app_source ? this.$route.query.app_source : false;
            this.client_id = this.$route.query.client_id ? this.$route.query.client_id : '';
            await this.getClientAssociationList();
            // if(this.app_source&&this.client_id!='') {
            //     this.selectedClient = this.client_id;
            //     this.switchClient();
            // } else {
            //      this.getClientAssociationList();  
            // }
        }
    }

</script>
<style scoped>
.o-cutsomSelect select {
    background-color: #335478 !important;
}
.add-word-break-all{
    word-break: break-all;
}
</style>



// WEBPACK FOOTER //
// src/components/switchClient.vue